import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { CheckCircle2Icon } from 'lucide-react';
interface Toast {
  id: number;
  title: string;
  body: string;
}
interface ToastContextValue {
  showToast: (title: string, body: string) => void;
}
const ToastContext = createContext<ToastContextValue | undefined>(undefined);
export function ToastProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [toasts, setToasts] = useState<Toast[]>([]);
  const showToast = useCallback((title: string, body: string) => {
    const id = Date.now();
    setToasts(prev => [...prev, {
      id,
      title,
      body
    }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 5000);
  }, []);
  const value = useMemo(() => ({
    showToast
  }), [showToast]);
  return <ToastContext.Provider value={value} data-id="element-444" data-mp="1lpotuiuk513p">
      {children}
      <div className="pointer-events-none fixed bottom-6 right-6 z-[60] flex flex-col gap-2" data-id="element-445" data-mp="1lsb08f5ppakc">
        {toasts.map(toast => <div key={toast.id} role="status" className="pointer-events-auto flex w-[270px] items-start gap-2.5 rounded-lg bg-navy-900 px-4 py-3 shadow-pop" data-id="element-446" data-mp="3jamtqf114zmf">
            <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" data-id="element-447" data-mp="3t80xbe1uttxb" />
            <div data-id="element-448" data-mp="1twjz6xpm6e4">
              <p className="text-[12.5px] font-bold text-white" data-id="element-449" data-mp="1ueqqxi0030a">{toast.title}</p>
              <p className="mt-0.5 text-[12px] text-white/70" data-id="element-450" data-mp="5vi1j5l6v8un">{toast.body}</p>
            </div>
          </div>)}
      </div>
    </ToastContext.Provider>;
}
export function useToast(): ToastContextValue {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within a ToastProvider');
  return ctx;
}